import { useState as m, useEffect as n } from "react";
import { getServerInfo as I } from "../constants/urls.js";
const S = (e = [], o) => {
  const [f, c] = m(!1), { appId: r } = I();
  return n(() => {
    var t;
    if (o) {
      const s = e != null && e.length ? ((t = e[e.length - 1]) == null ? void 0 : t.enabled_for) ?? [] : [];
      c(s.includes(+r));
    }
  }, [o, e, r]), f;
};
export {
  S as useIsOAuth2Enabled
};
